/* VanillaGoods — Events Guide (sections/vg-events-guide.liquid, sections/vg-events-teaser.liquid)
 * Data: snippets/vg-events-json.liquid (generated by tools/build_events.py)
 * Cards: snippets/vg-events-cards.liquid (server-rendered; this script filters them)
 */
(function () {
  'use strict';

  /* "Type of event" categories (generated by tools/build_events.py; first = primary). */
  var TOPIC = { 'coffee-tea': 'Coffee & Tea', dessert: 'Dessert & Chocolate', baking: 'Baking', vanilla: 'Vanilla', general: 'General food & drink' };
  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var DOW = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var DOW_LONG = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var SAVE_KEY = 'vg_events_saved_v1';
  /* All 50 states + DC with U.S. Census regions (used for the state picker and "nearby" suggestions). */
  var STATES = {
    AL: ['Alabama', 'South'], AK: ['Alaska', 'West'], AZ: ['Arizona', 'West'], AR: ['Arkansas', 'South'], CA: ['California', 'West'],
    CO: ['Colorado', 'West'], CT: ['Connecticut', 'Northeast'], DE: ['Delaware', 'South'], DC: ['District of Columbia', 'South'],
    FL: ['Florida', 'South'], GA: ['Georgia', 'South'], HI: ['Hawaii', 'West'], ID: ['Idaho', 'West'], IL: ['Illinois', 'Midwest'],
    IN: ['Indiana', 'Midwest'], IA: ['Iowa', 'Midwest'], KS: ['Kansas', 'Midwest'], KY: ['Kentucky', 'South'], LA: ['Louisiana', 'South'],
    ME: ['Maine', 'Northeast'], MD: ['Maryland', 'South'], MA: ['Massachusetts', 'Northeast'], MI: ['Michigan', 'Midwest'],
    MN: ['Minnesota', 'Midwest'], MS: ['Mississippi', 'South'], MO: ['Missouri', 'Midwest'], MT: ['Montana', 'West'],
    NE: ['Nebraska', 'Midwest'], NV: ['Nevada', 'West'], NH: ['New Hampshire', 'Northeast'], NJ: ['New Jersey', 'Northeast'],
    NM: ['New Mexico', 'West'], NY: ['New York', 'Northeast'], NC: ['North Carolina', 'South'], ND: ['North Dakota', 'Midwest'],
    OH: ['Ohio', 'Midwest'], OK: ['Oklahoma', 'South'], OR: ['Oregon', 'West'], PA: ['Pennsylvania', 'Northeast'],
    RI: ['Rhode Island', 'Northeast'], SC: ['South Carolina', 'South'], SD: ['South Dakota', 'Midwest'], TN: ['Tennessee', 'South'],
    TX: ['Texas', 'South'], UT: ['Utah', 'West'], VT: ['Vermont', 'Northeast'], VA: ['Virginia', 'South'], WA: ['Washington', 'West'],
    WV: ['West Virginia', 'South'], WI: ['Wisconsin', 'Midwest'], WY: ['Wyoming', 'West']
  };
  var REGIONS = ['Northeast', 'South', 'Midwest', 'West'];
  var DEFAULT_KINDS = { festival: true, holiday: true, trade: false };

  /* ---------- date helpers (all local dates as 'YYYY-MM-DD' strings) ---------- */
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function iso(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  function parse(s) { var p = s.split('-'); return new Date(+p[0], +p[1] - 1, +(p[2] || 1)); }
  function addDays(s, n) { var d = parse(s); d.setDate(d.getDate() + n); return iso(d); }
  function nextMonth(k) { var y = +k.slice(0, 4), m = +k.slice(5, 7) + 1; if (m > 12) { m = 1; y++; } return y + '-' + pad(m); }
  function prevMonth(k) { var y = +k.slice(0, 4), m = +k.slice(5, 7) - 1; if (m < 1) { m = 12; y--; } return y + '-' + pad(m); }
  function monthName(k) { return MONTHS[+k.slice(5, 7) - 1] + ' ' + k.slice(0, 4); }
  function daysBetween(a, b) { return Math.round((parse(b) - parse(a)) / 864e5); }
  function todayISO() { return iso(new Date()); }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function readSaved() {
    try { var v = JSON.parse(window.localStorage.getItem(SAVE_KEY) || '[]'); return Array.isArray(v) ? v : []; }
    catch (e) { return []; }
  }
  function writeSaved(list) {
    try { window.localStorage.setItem(SAVE_KEY, JSON.stringify(list)); } catch (e) { /* private mode */ }
  }

  function loadData(root) {
    var el = root.querySelector('script[data-vge-data]') || document.querySelector('script[data-vge-data]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  /* An item is still relevant if it ends today or later (TBA-month items: this month or later). */
  function isActive(it, today) {
    if (it.s) return it.e >= today;
    if (it.tbaMonth) return it.tbaMonth >= today.slice(0, 7);
    return false;
  }

  function relLabel(it, today) {
    if (!it.s) return 'Date TBA';
    if (it.s <= today && it.e >= today) return it.s === it.e ? 'Today' : 'Happening now';
    var n = daysBetween(today, it.s);
    if (n === 1) return 'Tomorrow';
    var dow = parse(it.s).getDay();
    if (n <= 6 && (dow === 6 || dow === 0)) return 'This weekend';
    if (n <= 30) return 'In ' + n + ' days';
    return DOW[dow] + ', ' + MON[parse(it.s).getMonth()] + ' ' + parse(it.s).getDate();
  }

  function whereLabel(it) {
    if (it.k === 'holiday') return 'Food holiday · celebrate at home';
    return [it.city, it.st].filter(Boolean).join(', ') || 'Location TBA';
  }

  function miniCard(it, today, href) {
    var d = it.s ? parse(it.s) : null;
    var topics = (it.topics || []).map(function (t) {
      return '<span class="vge-topic vge-topic--' + t + '">' + esc(TOPIC[t] || t) + '</span>';
    }).join('');
    return '<a class="vge-mini vge-mini--' + esc(it.kind) + '" href="' + esc(href) + '" data-vge-jump="' + esc(it.id) + '">' +
      '<span class="vge-mini__date" aria-hidden="true"><span>' + (d ? MON[d.getMonth()] : 'TBA') + '</span><strong>' + (d ? d.getDate() : '–') + '</strong></span>' +
      '<span class="vge-mini__body">' +
      '<span class="vge-mini__when">' + esc(relLabel(it, today)) + (it.pick ? ' · <span class="vge-mini__pick">VanillaGoods pick</span>' : '') + '</span>' +
      '<span class="vge-mini__name">' + esc(it.name) + '</span>' +
      '<span class="vge-mini__where">' + esc(whereLabel(it)) + '</span>' +
      '<span class="vge-mini__tags">' + topics + '</span>' +
      '</span></a>';
  }

  /* ---------- calendar export ---------- */
  function absUrl(u) {
    if (!u) return '';
    try { return new URL(u, window.location.origin).href; } catch (e) { return u; }
  }
  function compact(s) { return s.replace(/-/g, ''); }

  function googleLink(it) {
    var p = new URLSearchParams({
      action: 'TEMPLATE',
      text: it.name,
      dates: compact(it.s) + '/' + compact(addDays(it.e, 1)),
      details: (it.desc || '') + (it.url ? '\n\n' + absUrl(it.url) : ''),
      location: it.loc || ''
    });
    return 'https://calendar.google.com/calendar/render?' + p.toString();
  }

  function outlookLink(it) {
    var p = new URLSearchParams({
      path: '/calendar/action/compose', rru: 'addevent', allday: 'true',
      subject: it.name, startdt: it.s, enddt: addDays(it.e, 1),
      body: (it.desc || '') + (it.url ? ' ' + absUrl(it.url) : ''),
      location: it.loc || ''
    });
    return 'https://outlook.live.com/calendar/0/deeplink/compose?' + p.toString();
  }

  function icsEscape(s) {
    return String(s || '').replace(/\\/g, '\\\\').replace(/;/g, '\\;').replace(/,/g, '\\,').replace(/\r?\n/g, '\\n');
  }

  /* RFC 5545 line folding at 75 octets (UTF-8 aware). */
  function fold(line) {
    var enc = window.TextEncoder ? new TextEncoder() : null;
    if (!enc) return line;
    var out = [], cur = '', curBytes = 0, limit = 75;
    for (var i = 0; i < line.length; i++) {
      var ch = line[i];
      var code = line.charCodeAt(i);
      if (code >= 0xD800 && code <= 0xDBFF && i + 1 < line.length) { ch += line[++i]; }
      var b = enc.encode(ch).length;
      if (curBytes + b > limit) { out.push(cur); cur = ' ' + ch; curBytes = 1 + b; limit = 75; }
      else { cur += ch; curBytes += b; }
    }
    out.push(cur);
    return out.join('\r\n');
  }

  function buildICS(it) {
    var now = new Date();
    var stamp = now.getUTCFullYear() + pad(now.getUTCMonth() + 1) + pad(now.getUTCDate()) + 'T' +
      pad(now.getUTCHours()) + pad(now.getUTCMinutes()) + pad(now.getUTCSeconds()) + 'Z';
    var lines = [
      'BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//VanillaGoods//Events Guide//EN', 'CALSCALE:GREGORIAN', 'METHOD:PUBLISH',
      'BEGIN:VEVENT',
      'UID:' + it.id + '@vanillagoods.com',
      'DTSTAMP:' + stamp,
      'DTSTART;VALUE=DATE:' + compact(it.s),
      'DTEND;VALUE=DATE:' + compact(addDays(it.e, 1)),
      'SUMMARY:' + icsEscape(it.name),
      'DESCRIPTION:' + icsEscape((it.desc || '') + (it.url ? '\n' + absUrl(it.url) : '')),
      'TRANSP:TRANSPARENT'
    ];
    if (it.loc) lines.push('LOCATION:' + icsEscape(it.loc));
    if (it.url) lines.push('URL:' + absUrl(it.url));
    lines.push('END:VEVENT', 'END:VCALENDAR');
    return lines.map(fold).join('\r\n') + '\r\n';
  }

  function downloadICS(it) {
    var blob = new Blob([buildICS(it)], { type: 'text/calendar;charset=utf-8' });
    var url = URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url;
    a.download = it.id + '.ics';
    document.body.appendChild(a);
    a.click();
    setTimeout(function () { URL.revokeObjectURL(url); a.remove(); }, 1500);
  }

  /* ======================================================================
   * Teaser (homepage) — next few events from the same data
   * ==================================================================== */
  function initTeaser(root, data) {
    var track = root.querySelector('[data-vge-spot]');
    if (!track) return;
    var today = todayISO();
    var limit = parseInt(root.getAttribute('data-vge-limit'), 10) || 4;
    var withHolidays = root.getAttribute('data-vge-holidays') !== 'false';
    var pageUrl = root.getAttribute('data-vge-page-url') || '/pages/events';
    var list = data.items.filter(function (it) {
      return it.s && isActive(it, today) && it.kind !== 'trade' && (withHolidays || it.k !== 'holiday');
    }).slice(0, limit);
    if (!list.length) { root.hidden = true; return; }
    track.innerHTML = list.map(function (it) { return miniCard(it, today, pageUrl + '#vge-' + it.id); }).join('');
  }

  /* ======================================================================
   * Guide (hub page)
   * ==================================================================== */
  function initGuide(root, data) {
    var today = todayISO();
    var thisMonth = today.slice(0, 7);
    var byId = {};
    data.items.forEach(function (it) { byId[it.id] = it; });

    var firstMonth = data.first > thisMonth ? data.first : thisMonth;
    var lastMonth = data.last;
    var months = [];
    for (var k = firstMonth; k <= lastMonth; k = nextMonth(k)) months.push(k);

    var agenda = root.querySelector('[data-vge-agenda]');
    var cards = agenda ? Array.prototype.slice.call(agenda.querySelectorAll('.vge-card[data-id]')) : [];
    var monthEls = agenda ? Array.prototype.slice.call(agenda.querySelectorAll('.vge-month[data-month]')) : [];
    var tbaEls = Array.prototype.slice.call(root.querySelectorAll('.vge-tba[data-id]'));
    var tbaTopicMap = {};
    (data.tba || []).forEach(function (t) { tbaTopicMap[t.id] = t; });   // rows themselves load later (page weight)
    tbaEls.forEach(function (li) {
      var q = function (sel) { var n = li.querySelector(sel); return n ? n.textContent.trim() : ''; };
      tbaTopicMap[li.getAttribute('data-id')] = {
        id: li.getAttribute('data-id'),
        topics: (li.getAttribute('data-topics') || '').split(' '),
        st: li.getAttribute('data-st') || '', region: li.getAttribute('data-region') || '',
        name: q('.vge-tba__name'), loc: q('.vge-tba__meta'), note: q('.vge-tba__note'),
        text: li.textContent.toLowerCase()
      };
    });

    var el = {
      q: root.querySelector('[data-vge-q]'),
      topics: root.querySelectorAll('[data-vge-topic]'),
      kinds: root.querySelectorAll('[data-vge-kind]'),
      where: root.querySelector('[data-vge-where]'),
      saved: root.querySelector('[data-vge-saved]'),
      savedCount: root.querySelector('[data-vge-saved-count]'),
      reset: root.querySelectorAll('[data-vge-reset]'),
      status: root.querySelector('[data-vge-status]'),
      empty: root.querySelector('[data-vge-empty]'),
      statebox: root.querySelector('[data-vge-statebox]'),
      rail: root.querySelector('[data-vge-rail]'),
      views: root.querySelectorAll('[data-vge-view]'),
      listWrap: root.querySelector('[data-vge-listwrap]'),
      gridWrap: root.querySelector('[data-vge-gridwrap]'),
      grid: root.querySelector('[data-vge-grid]'),
      gridTitle: root.querySelector('[data-vge-grid-title]'),
      gridPrev: root.querySelector('[data-vge-grid-prev]'),
      gridNext: root.querySelector('[data-vge-grid-next]'),
      gridTba: root.querySelector('[data-vge-grid-tba]'),
      day: root.querySelector('[data-vge-day]'),
      spot: root.querySelector('[data-vge-spot]'),
      spotTitle: root.querySelector('[data-vge-spot-title]'),
      spotSub: root.querySelector('[data-vge-spot-sub]'),
      filterToggle: root.querySelector('[data-vge-filter-toggle]'),
      filterPanel: root.querySelector('[data-vge-filters]'),
      filterBadge: root.querySelector('[data-vge-filter-badge]'),
      tbaEmpty: root.querySelector('[data-vge-tba-empty]'),
      toast: root.querySelector('[data-vge-toast]')
    };

    var state = {
      topics: [], kinds: Object.assign({}, DEFAULT_KINDS), where: '', q: '', saved: false,
      view: 'list', month: firstMonth, day: null
    };
    var saved = readSaved();

    /* ---------- URL state ---------- */
    function readUrl() {
      var p = new URLSearchParams(window.location.search);
      var tp = (p.get('type') || p.get('topic') || '').split(',').filter(function (t) { return TOPIC[t]; });
      if (tp.length) state.topics = tp;
      if (p.has('types')) {
        var t = p.get('types').split(',');
        state.kinds = { festival: t.indexOf('festival') > -1, holiday: t.indexOf('holiday') > -1, trade: t.indexOf('trade') > -1 };
      }
      var w = p.get('where');
      if (w && ((w.indexOf('s:') === 0 && STATES[w.slice(2)]) || (w.indexOf('r:') === 0 && REGIONS.indexOf(w.slice(2)) > -1))) state.where = w;
      if (p.get('q')) state.q = p.get('q');
      if (p.get('saved') === '1') state.saved = true;
      if (p.get('view') === 'month') state.view = 'grid';
      if (p.get('month') && /^\d{4}-\d{2}$/.test(p.get('month')) && p.get('month') >= firstMonth && p.get('month') <= lastMonth) state.month = p.get('month');
    }
    function writeUrl() {
      var p = new URLSearchParams(window.location.search);
      ['type', 'topic', 'types', 'where', 'q', 'saved', 'view', 'month'].forEach(function (k) { p.delete(k); });
      if (state.topics.length) p.set('type', state.topics.join(','));
      var kinds = Object.keys(state.kinds).filter(function (k) { return state.kinds[k]; });
      var def = Object.keys(DEFAULT_KINDS).filter(function (k) { return DEFAULT_KINDS[k]; });
      if (kinds.join() !== def.join()) p.set('types', kinds.join(','));
      if (state.where) p.set('where', state.where);
      if (state.q) p.set('q', state.q);
      if (state.saved) p.set('saved', '1');
      if (state.view === 'grid') { p.set('view', 'month'); p.set('month', state.month); }
      var qs = p.toString();
      try { window.history.replaceState(null, '', window.location.pathname + (qs ? '?' + qs : '') + window.location.hash); } catch (e) { /* sandboxed */ }
    }

    /* ---------- matching ---------- */
    function hay(it) {
      if (!it._hay) {
        it._hay = [it.name, it.city, it.state, it.st, it.venue, (it.topics || []).map(function (t) { return TOPIC[t]; }).join(' '),
          it.k === 'holiday' ? 'food holiday national day' : (it.kind === 'trade' ? 'trade show' : 'festival')].join(' ').toLowerCase();
      }
      return it._hay;
    }
    function kindOk(kind, isHoliday) {
      if (isHoliday) return state.kinds.holiday;
      if (kind === 'trade') return state.kinds.trade;
      return state.kinds.festival;
    }
    function whereOk(st, region) {
      if (!state.where) return true;
      if (state.where.indexOf('r:') === 0) return region === state.where.slice(2);
      if (state.where.indexOf('s:') === 0) return st === state.where.slice(2);
      return true;
    }
    function queryOk(text) {
      if (!state.q) return true;
      return state.q.toLowerCase().split(/\s+/).filter(Boolean).every(function (t) { return text.indexOf(t) > -1; });
    }
    /* OR within the "Type of event" facet, AND across facets */
    function topicOk(list) {
      if (!state.topics.length) return true;
      list = list || [];
      return state.topics.some(function (t) { return list.indexOf(t) > -1; });
    }
    /* Facet counts: how many items each type would show, given every other filter */
    function topicCounts() {
      var keep = state.topics; state.topics = [];
      var c = {};
      data.items.forEach(function (it) {
        if (!matches(it)) return;
        (it.topics || []).forEach(function (t) { c[t] = (c[t] || 0) + 1; });
      });
      Object.keys(tbaTopicMap).forEach(function (id) {
        var t = tbaTopicMap[id];
        if (tbaOk(t, false)) t.topics.forEach(function (k) { c[k] = (c[k] || 0) + 1; });
      });
      state.topics = keep;
      return c;
    }
    function matchesExceptWhere(it) {
      var keep = state.where; state.where = '';
      var ok = matches(it);
      state.where = keep;
      return ok;
    }
    function tbaOk(t, ignoreWhere) {
      return topicOk(t.topics) &&
        (ignoreWhere || whereOk(t.st, t.region)) && queryOk(t.text) && kindOk('festival', false) &&
        (!state.saved || saved.indexOf(t.id) > -1);
    }
    function matches(it) {
      if (!isActive(it, today)) return false;
      if (!topicOk(it.topics)) return false;
      if (!kindOk(it.kind, it.k === 'holiday')) return false;
      if (it.k !== 'holiday' && !whereOk(it.st, it.region)) return false; // food holidays are nationwide
      if (it.k !== 'holiday' && !nearOk(it)) return false;                 // food holidays are at home, everywhere
      if (!queryOk(hay(it))) return false;
      if (state.saved && saved.indexOf(it.id) < 0) return false;
      return true;
    }
    function monthOf(it) { return it.s ? it.s.slice(0, 7) : it.tbaMonth; }
    function overlapsMonth(it, m) {
      if (!it.s) return it.tbaMonth === m;
      return it.s.slice(0, 7) <= m && it.e.slice(0, 7) >= m;
    }


    /* ---------- events near me (Oct 23 2026) ----------
       ZIP -> lat/lon through the site's search-only us_zips lookup (same as the farmers market finder), or the
       browser's location (asked only on tap, kept in this page only). The ZIP is remembered on this device. */
    var NEAR_KEY = 'vg_events_zip_v1';
    var near = null;                      // {lat, lon, label}
    var radius = 100;
    var nearEl = {
      form: root.querySelector('[data-vge-near-form]'), zip: root.querySelector('[data-vge-zip]'),
      geo: root.querySelector('[data-vge-geo]'), radius: root.querySelector('[data-vge-radius]'),
      msg: root.querySelector('[data-vge-near-msg]'), list: root.querySelector('[data-vge-near-list]'),
      clear: root.querySelector('[data-vge-near-clear]')
    };
    function miles(a, b) {
      var R = 3958.8, r = Math.PI / 180;
      var dLat = (b.lat - a.lat) * r, dLon = (b.lon - a.lon) * r;
      var h = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(a.lat * r) * Math.cos(b.lat * r) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
      return 2 * R * Math.asin(Math.sqrt(h));
    }
    function distOf(it) { return (near && it.lat != null) ? miles(near, it) : null; }
    function nearOk(it) {
      if (!near || !radius) return true;
      var d = distOf(it);
      if (d == null) return !!(near.st && it.st === near.st);   // no map point: match by state
      return d <= radius;
    }
    function renderNear() {
      if (!nearEl.list) return;
      if (nearEl.clear) nearEl.clear.hidden = !near;
      if (!near) { nearEl.list.hidden = true; nearEl.list.innerHTML = ''; return; }
      var list = data.items.filter(function (it) { return it.k !== 'holiday' && it.s && matches(it) && distOf(it) != null; })
        .sort(function (a, b) { return distOf(a) - distOf(b); }).slice(0, 8);
      if (nearEl.msg) nearEl.msg.textContent = list.length ? 'Closest events to ' + near.label + (radius ? ' (within ' + radius + ' miles)' : '') + ':' :
        'No events within ' + radius + ' miles of ' + near.label + ' yet. Try a bigger distance. Food holidays below work anywhere.';
      nearEl.list.innerHTML = list.map(function (it) {
        var d = Math.round(distOf(it));
        return '<a class="vge-near__item" href="#vge-' + esc(it.id) + '"><span><b>' + esc(it.name) + '</b><small>' +
          esc(fmtShort(it)) + ' · ' + esc(whereLabel(it)) + '</small></span><span class="vge-near__mi">' + d + ' mi</span></a>';
      }).join('');
      nearEl.list.hidden = !list.length;
    }
    function fmtShort(it) {
      var s = parse(it.s), e = parse(it.e);
      var t = MON[s.getMonth()] + ' ' + s.getDate();
      if (it.e !== it.s) t += ' – ' + (e.getMonth() !== s.getMonth() ? MON[e.getMonth()] + ' ' : '') + e.getDate();
      return t + ', ' + s.getFullYear();
    }
    function setNear(lat, lon, label, st) { near = { lat: lat, lon: lon, label: label, st: st || '' }; apply(); }
    function lookupZip(zip) {
      var vgh = document.getElementById('VGH'), host = vgh && vgh.dataset.ppHost, key = vgh && vgh.dataset.ppKey;
      if (!/^\d{5}$/.test(zip)) { nearEl.msg.textContent = 'Enter a 5-digit ZIP code.'; return; }
      if (!host || !key) { nearEl.msg.textContent = 'ZIP search is unavailable right now. Pick your state above instead.'; return; }
      nearEl.msg.textContent = 'Finding events near ' + zip + '…';
      fetch('https://' + host + '/collections/us_zips/documents/search?q=*&per_page=1&filter_by=zip:=' + zip, { headers: { 'X-TYPESENSE-API-KEY': key } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (zr) {
          var z = zr.hits && zr.hits[0] && zr.hits[0].document;
          if (!z || !z.location) throw new Error('zip');
          try { localStorage.setItem(NEAR_KEY, zip); } catch (e) {}
          setNear(z.location[0], z.location[1], zip, z.state_code || z.st || z.state || '');
        })
        .catch(function () { nearEl.msg.textContent = "We couldn't find that ZIP code. Check it, or pick your state above."; });
    }
    if (nearEl.form) {
      nearEl.form.addEventListener('submit', function (e) { e.preventDefault(); lookupZip(nearEl.zip.value.trim()); });
      nearEl.radius.addEventListener('change', function () { radius = +nearEl.radius.value; apply(); });
      if (nearEl.clear) nearEl.clear.addEventListener('click', function () {
        near = null; nearEl.msg.textContent = ''; nearEl.zip.value = '';
        try { localStorage.removeItem(NEAR_KEY); } catch (e) {}
        apply();
      });
      if (nearEl.geo) {
        if (!('geolocation' in navigator)) nearEl.geo.hidden = true;
        nearEl.geo.addEventListener('click', function () {
          nearEl.msg.textContent = 'Asking your browser for your location…';
          navigator.geolocation.getCurrentPosition(function (pos) {
            setNear(pos.coords.latitude, pos.coords.longitude, 'your location');
          }, function () { nearEl.msg.textContent = 'Location is off. Enter a ZIP code instead.'; }, { maximumAge: 600000, timeout: 10000 });
        });
      }
    }

    /* ---------- later months load on demand (Oct 24 2026: page weight) ----------
       The page ships the first months' cards; the rest come from assets/vg-events-more-N.json when the visitor
       scrolls near them, uses search/filters/near me/month view, follows a deep link, or after a short idle. */
    var moreUrls = ((agenda && agenda.getAttribute('data-vge-more')) || '').split('|').filter(Boolean);
    var moreLoaded = !moreUrls.length, moreLoading = null;
    function loadMore() {
      if (moreLoaded) return Promise.resolve();
      if (moreLoading) return moreLoading;
      moreLoading = Promise.all(moreUrls.map(function (u) { return fetch(u).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); }); }))
        .then(function (parts) {
          parts.forEach(function (part) {
            Object.keys(part).forEach(function (m) {
              if (m === 'tba') {
                var ul = root.querySelector('[data-vge-tba]');
                if (ul) ul.insertAdjacentHTML('beforeend', part[m]);
                return;
              }
              var list = agenda.querySelector('.vge-month[data-month="' + m + '"] .vge-month__list');
              if (!list) return;
              var empty = list.querySelector('.vge-month__empty');
              if (empty) empty.insertAdjacentHTML('beforebegin', part[m]); else list.insertAdjacentHTML('beforeend', part[m]);
            });
          });
          cards = Array.prototype.slice.call(agenda.querySelectorAll('.vge-card[data-id]'));
          tbaEls = Array.prototype.slice.call(root.querySelectorAll('.vge-tba[data-id]'));
          moreLoaded = true;
          if (el.q && el.q.value.trim() !== state.q) state.q = el.q.value.trim();   // typed while loading: keep it
          apply();
          syncSaveButtons();
        })
        .catch(function () { moreLoading = null; });
      return moreLoading;
    }
    if (!moreLoaded) {
      ['input', 'change', 'submit'].forEach(function (t) { root.addEventListener(t, function () { loadMore(); }, true); });
      root.addEventListener('click', function (e) {
        if (e.target.closest('[data-vge-topic],[data-vge-kind],[data-vge-saved],[data-vge-view],[data-vge-rail],[data-vge-geo],[data-vge-grid-prev],[data-vge-grid-next],[data-vge-filter-toggle]')) loadMore();
      }, true);
      var lastShell = agenda && agenda.querySelector('[data-vge-lazy-start]');
      if (lastShell && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) { if (es.some(function (x) { return x.isIntersecting; })) { io.disconnect(); loadMore(); } }, { rootMargin: '1200px 0px' });
        io.observe(lastShell);
      }
      setTimeout(loadMore, 8000);
    }

    /* ---------- apply filters to the agenda ---------- */
    var counts = {};
    function apply() {
      counts = {};
      months.forEach(function (m) { counts[m] = 0; });
      var nEvents = 0, nHol = 0;

      cards.forEach(function (card) {
        var it = byId[card.getAttribute('data-id')];
        card.hidden = !(it && matches(it));
      });
      data.items.forEach(function (it) {          // counts cover every event, including months not loaded yet
        if (!matches(it)) return;
        var m = monthOf(it);
        if (counts[m] != null) counts[m]++;
        if (it.k === 'holiday') nHol++; else nEvents++;
      });

      monthEls.forEach(function (sec) {
        var m = sec.getAttribute('data-month');
        var n = counts[m] || 0;
        sec.hidden = m < firstMonth || n === 0;
        var c = sec.querySelector('[data-vge-count]');
        if (c) c.textContent = n + (n === 1 ? ' item' : ' items');
      });

      var tbaShown = 0;
      tbaEls.forEach(function (li) {
        var ok = tbaOk(tbaTopicMap[li.getAttribute('data-id')], false);
        li.hidden = !ok;
        if (ok) tbaShown++;
      });
      if (!moreLoaded) tbaShown = Object.keys(tbaTopicMap).filter(function (id) { return tbaOk(tbaTopicMap[id], false); }).length;
      if (el.tbaEmpty) el.tbaEmpty.hidden = tbaShown > 0;

      if (el.status) {
        var parts = [];
        var placeTxt = whereName(state.where);
        if (state.kinds.festival || state.kinds.trade) parts.push(nEvents + (nEvents === 1 ? ' event' : ' events') + (placeTxt ? ' in ' + placeTxt : ''));
        if (state.kinds.holiday) parts.push(nHol + (placeTxt ? ' nationwide' : '') + (nHol === 1 ? ' food holiday' : ' food holidays'));
        el.status.textContent = 'Showing ' + (parts.join(' and ') || 'nothing') + ' · ' + monthName(firstMonth) + ' – ' + monthName(lastMonth);
      }
      if (el.empty) el.empty.hidden = (nEvents + nHol) > 0;

      updateWhereOptions();
      renderNear();
      renderStateBox();
      syncControls();
      renderRail();
      if (state.view === 'grid') renderGrid();
      writeUrl();
    }

    /* ---------- controls ---------- */
    function activeFilterCount() {
      var n = 0;
      if (state.topics.length) n++;
      Object.keys(DEFAULT_KINDS).forEach(function (k) { if (state.kinds[k] !== DEFAULT_KINDS[k]) n++; });
      if (state.where) n++;
      if (state.saved) n++;
      return n;
    }
    function syncControls() {
      var tc = topicCounts();
      Array.prototype.forEach.call(el.topics, function (b) {
        var k = b.getAttribute('data-vge-topic');
        b.setAttribute('aria-pressed', String(k === 'all' ? !state.topics.length : state.topics.indexOf(k) > -1));
        var n = b.querySelector('[data-vge-topic-n]');
        if (n && k !== 'all') {
          n.textContent = tc[k] || 0;
          // hide types that would show nothing (e.g. General is all trade shows, which are off by default)
          b.hidden = !tc[k] && state.topics.indexOf(k) < 0;
        }
      });
      Array.prototype.forEach.call(el.kinds, function (b) { b.setAttribute('aria-pressed', String(!!state.kinds[b.getAttribute('data-vge-kind')])); });
      if (el.where && el.where.value !== state.where) el.where.value = state.where;
      if (el.q && el.q.value !== state.q) el.q.value = state.q;
      if (el.saved) el.saved.setAttribute('aria-pressed', String(state.saved));
      if (el.savedCount) el.savedCount.textContent = saved.length;
      Array.prototype.forEach.call(el.views, function (b) {
        var on = b.getAttribute('data-vge-view') === state.view;
        b.setAttribute('aria-pressed', String(on));
      });
      if (el.listWrap) el.listWrap.hidden = state.view !== 'list';
      if (el.gridWrap) el.gridWrap.hidden = state.view !== 'grid';
      var n = activeFilterCount() + (state.q ? 1 : 0);
      var inPanel = activeFilterCount() - (state.where ? 1 : 0); // state picker sits outside the Filters panel
      if (el.filterBadge) { el.filterBadge.textContent = inPanel; el.filterBadge.hidden = inPanel === 0; }
      Array.prototype.forEach.call(el.reset, function (b) { b.hidden = n === 0 && b.hasAttribute('data-vge-reset-auto'); });
    }

    function resetFilters() {
      state.topics = []; state.kinds = Object.assign({}, DEFAULT_KINDS); state.where = ''; state.q = ''; state.saved = false;
      apply();
    }

    /* ---------- state picker (all 50 states + DC, with live counts) ---------- */
    function whereName(w) {
      if (!w) return '';
      if (w.indexOf('s:') === 0) return STATES[w.slice(2)] ? STATES[w.slice(2)][0] : w.slice(2);
      if (w.indexOf('r:') === 0) return 'the ' + w.slice(2);
      return '';
    }
    function buildWhere() {
      if (!el.where) return;
      var html = '<option value="">All states</option><optgroup label="States">';
      Object.keys(STATES).sort(function (a, b) { return STATES[a][0].localeCompare(STATES[b][0]); }).forEach(function (st) {
        html += '<option value="s:' + st + '">' + esc(STATES[st][0]) + '</option>';
      });
      html += '</optgroup><optgroup label="Or browse a region">';
      REGIONS.forEach(function (r) { html += '<option value="r:' + r + '">' + r + '</option>'; });
      el.where.innerHTML = html + '</optgroup>';
    }
    /* Count events per state/region under every filter except location. */
    function locationCounts() {
      var c = {};
      function add(st, region) {
        if (st) c['s:' + st] = (c['s:' + st] || 0) + 1;
        var r = region || (STATES[st] && STATES[st][1]);
        if (r) c['r:' + r] = (c['r:' + r] || 0) + 1;
      }
      data.items.forEach(function (it) { if (it.k === 'event' && matchesExceptWhere(it)) add(it.st, it.region); });
      Object.keys(tbaTopicMap).forEach(function (id) { var t = tbaTopicMap[id]; if (tbaOk(t, true)) add(t.st, t.region); });
      return c;
    }
    function updateWhereOptions() {
      if (!el.where) return;
      var c = locationCounts();
      Array.prototype.forEach.call(el.where.options, function (o) {
        if (!o.value) return;
        var base = o.value.indexOf('s:') === 0 ? STATES[o.value.slice(2)][0] : o.value.slice(2);
        var n = c[o.value] || 0;
        o.textContent = base + ' (' + n + ')';
      });
    }

    /* Summary of everything in the chosen state/region, independent of month */
    function renderStateBox() {
      var box = el.statebox;
      if (!box) return;
      if (!state.where) { box.hidden = true; box.innerHTML = '<span></span>'; return; }
      var place = whereName(state.where);
      var dated = data.items.filter(function (it) { return it.k === 'event' && matches(it); });
      var soon = Object.keys(tbaTopicMap).map(function (id) { return tbaTopicMap[id]; }).filter(function (t) { return tbaOk(t, false); });
      var total = dated.length + soon.length;
      var html = '<div class="vge-statebox__head"><div><h3 class="vge-statebox__title">' +
        (total ? 'Events in ' + esc(place) : 'No events in ' + esc(place) + ' yet') + '</h3>' +
        '<p class="vge-statebox__sub">';
      if (total) {
        var bits = [];
        if (dated.length) bits.push(dated.length + ' on the calendar');
        if (soon.length) bits.push(soon.length + (soon.length === 1 ? ' with a date coming soon' : ' with dates coming soon'));
        html += esc(bits.join(' · ')) + (state.kinds.holiday ? '. Food holidays below can be celebrated anywhere.' : '.');
      } else {
        html += 'We haven\u2019t found a vanilla, coffee or tea festival here' + (state.topics.length || state.q || state.saved ? ' that matches your other filters' : '') + '. ';
        html += state.kinds.holiday ? 'You can still celebrate the food holidays below at home.' : '';
      }
      html += '</p></div><button type="button" class="vge-link" data-vge-where-set="">Show all states</button></div>';

      if (total) {
        html += '<div class="vge-statebox__list">' + dated.map(function (it) {
          return miniCard(it, today, '#vge-' + it.id);
        }).join('') + soon.map(function (t) {
          return '<a class="vge-mini vge-mini--soon" href="#vge-tba-' + esc(t.id) + '" data-vge-jump-tba="' + esc(t.id) + '">' +
            '<span class="vge-mini__date" aria-hidden="true"><span>Date</span><strong>TBA</strong></span>' +
            '<span class="vge-mini__body"><span class="vge-mini__when">Date coming soon</span>' +
            '<span class="vge-mini__name">' + esc(t.name) + '</span><span class="vge-mini__where">' + esc(t.loc) + '</span></span></a>';
        }).join('') + '</div>';
      } else if (state.where.indexOf('s:') === 0) {
        var region = STATES[state.where.slice(2)] && STATES[state.where.slice(2)][1];
        var rc = region ? (locationCounts()['r:' + region] || 0) : 0;
        html += '<div class="vge-statebox__actions">' +
          (rc ? '<button type="button" class="vge-btn vge-btn--primary" data-vge-where-set="r:' + region + '">See ' + rc + ' nearby in the ' + region + '</button>' : '') +
          '<a class="vge-btn vge-btn--ghost" href="' + esc(box.getAttribute('data-submit-anchor') || '#') + '">Know an event here? Tell us</a></div>';
      }
      box.innerHTML = html;
      box.hidden = false;
    }

    /* ---------- month rail ---------- */
    function renderRail() {
      if (!el.rail) return;
      var active = state.view === 'grid' ? state.month : (el.rail.getAttribute('data-active') || firstMonth);
      el.rail.innerHTML = months.map(function (m, i) {
        var n = counts[m] || 0;
        var showYear = i === 0 || m.slice(5) === '01';
        return '<button type="button" class="vge-pill' + (n ? '' : ' is-empty') + (m === active ? ' is-active' : '') + '" data-vge-month="' + m + '"' +
          (m === active ? ' aria-current="true"' : '') + ' aria-label="' + monthName(m) + ', ' + n + ' items">' +
          '<span class="vge-pill__m">' + MON[+m.slice(5) - 1] + (showYear ? ' <small>' + m.slice(0, 4) + '</small>' : '') + '</span>' +
          '<span class="vge-pill__n">' + n + '</span></button>';
      }).join('');
    }
    function setRailActive(m) {
      if (!el.rail) return;
      el.rail.setAttribute('data-active', m);
      Array.prototype.forEach.call(el.rail.querySelectorAll('.vge-pill'), function (p) {
        var on = p.getAttribute('data-vge-month') === m;
        p.classList.toggle('is-active', on);
        if (on) {
          p.setAttribute('aria-current', 'true');
          var left = p.offsetLeft - (el.rail.clientWidth - p.offsetWidth) / 2;
          el.rail.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
        } else p.removeAttribute('aria-current');
      });
    }

    function stickyOffset() {
      var bar = root.querySelector('.vge-bar');
      var top = parseInt(getComputedStyle(root).getPropertyValue('--vge-sticky'), 10) || 0;
      return top + (bar ? bar.offsetHeight : 0) + 12;
    }
    function scrollToEl(target) {
      var y = target.getBoundingClientRect().top + window.pageYOffset - stickyOffset();
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
    }

    function goMonth(m) {
      if (state.view === 'grid') {
        state.month = m; state.day = null; renderGrid(); setRailActive(m); writeUrl();
        return;
      }
      var sec = agenda && agenda.querySelector('.vge-month[data-month="' + m + '"]');
      if (!sec || sec.hidden) {
        // nothing this month for current filters: jump to the next month that has items
        var later = months.filter(function (x) { return x >= m && counts[x]; })[0];
        if (!later) { toast('Nothing in ' + monthName(m) + ' for these filters'); return; }
        if (later !== m) toast('Nothing in ' + monthName(m) + ' — jumped to ' + monthName(later));
        sec = agenda.querySelector('.vge-month[data-month="' + later + '"]');
        m = later;
      }
      setRailActive(m);
      scrollToEl(sec);
    }

    /* scroll spy (list view) */
    var spy = null;
    function setupSpy() {
      if (!('IntersectionObserver' in window) || !monthEls.length) return;
      var visible = {};
      spy = new IntersectionObserver(function (entries) {
        if (state.view !== 'list') return;
        entries.forEach(function (e) { visible[e.target.getAttribute('data-month')] = e.isIntersecting; });
        var first = months.filter(function (m) { return visible[m]; })[0];
        if (first && first !== el.rail.getAttribute('data-active')) setRailActive(first);
      }, { rootMargin: '-' + stickyOffset() + 'px 0px -55% 0px', threshold: 0 });
      monthEls.forEach(function (s) { spy.observe(s); });
    }

    /* ---------- month grid ---------- */
    function cloneCard(id) {
      var src = document.getElementById('vge-' + id);
      if (!src) return null;
      var c = src.cloneNode(true);
      c.removeAttribute('id');
      c.hidden = false;
      c.classList.add('vge-card--clone');
      return c;
    }

    function renderGrid() {
      if (!el.grid) return;
      var m = state.month;
      if (el.gridTitle) el.gridTitle.textContent = monthName(m);
      if (el.gridPrev) el.gridPrev.disabled = m <= firstMonth;
      if (el.gridNext) el.gridNext.disabled = m >= lastMonth;

      var list = data.items.filter(function (it) { return matches(it) && overlapsMonth(it, m); });
      var dated = list.filter(function (it) { return it.s; });
      var tba = list.filter(function (it) { return !it.s; });

      var first = parse(m + '-01');
      var daysIn = new Date(first.getFullYear(), first.getMonth() + 1, 0).getDate();
      var lead = first.getDay();
      var html = DOW.map(function (d) { return '<div class="vge-grid__dow" aria-hidden="true">' + d + '</div>'; }).join('');
      // (non-empty: Dawn hides div:empty)
      for (var i = 0; i < lead; i++) html += '<div class="vge-day vge-day--pad" aria-hidden="true"><span></span></div>';

      var firstWithItems = null;
      for (var d = 1; d <= daysIn; d++) {
        var day = m + '-' + pad(d);
        var evs = dated.filter(function (it) { return it.s <= day && it.e >= day; });
        if (evs.length && !firstWithItems && day >= today) firstWithItems = day;
        var cls = 'vge-day' + (day === today ? ' is-today' : '') + (day < today ? ' is-past' : '') + (day === state.day ? ' is-selected' : '');
        if (!evs.length) {
          html += '<div class="' + cls + '"><span class="vge-day__n">' + d + '</span></div>';
          continue;
        }
        var labels = evs.slice(0, 2).map(function (it) {
          return '<span class="vge-ev vge-ev--' + it.topics[0] + (it.k === 'holiday' ? ' vge-ev--holiday' : '') + '">' + esc(it.name) + '</span>';
        }).join('');
        var dots = evs.slice(0, 4).map(function (it) { return '<i class="vge-dot vge-dot--' + it.topics[0] + '"></i>'; }).join('');
        html += '<button type="button" class="' + cls + ' has-items" data-vge-day-btn="' + day + '" aria-pressed="' + (day === state.day) + '" ' +
          'aria-label="' + DOW_LONG[parse(day).getDay()] + ', ' + MONTHS[parse(day).getMonth()] + ' ' + d + ': ' + evs.length + (evs.length === 1 ? ' item' : ' items') + '">' +
          '<span class="vge-day__n">' + d + '</span><span class="vge-day__evs">' + labels +
          (evs.length > 2 ? '<span class="vge-ev vge-ev--more">+' + (evs.length - 2) + ' more</span>' : '') + '</span>' +
          '<span class="vge-day__dots" aria-hidden="true">' + dots + '</span></button>';
      }
      el.grid.innerHTML = html;

      if (el.gridTba) {
        el.gridTba.hidden = !tba.length;
        el.gridTba.innerHTML = tba.length ? '<strong>Date TBA this month:</strong> ' + tba.map(function (it) {
          return '<a href="#vge-' + esc(it.id) + '" data-vge-jump="' + esc(it.id) + '">' + esc(it.name) + '</a>';
        }).join(', ') : '';
      }

      if (!state.day || state.day.slice(0, 7) !== m) state.day = firstWithItems || (dated[0] && (dated[0].s.slice(0, 7) === m ? dated[0].s : m + '-01')) || null;
      renderDay();
      Array.prototype.forEach.call(el.grid.querySelectorAll('[data-vge-day-btn]'), function (b) {
        var on = b.getAttribute('data-vge-day-btn') === state.day;
        b.classList.toggle('is-selected', on);
        b.setAttribute('aria-pressed', String(on));
      });
    }

    function renderDay() {
      if (!el.day) return;
      var day = state.day;
      el.day.innerHTML = '';
      if (!day) {
        el.day.innerHTML = '<p class="vge-day-panel__empty">Nothing this month for these filters. Try another month or <button type="button" class="vge-link" data-vge-reset>reset filters</button>.</p>';
        return;
      }
      var evs = data.items.filter(function (it) { return it.s && matches(it) && it.s <= day && it.e >= day; });
      var d = parse(day);
      var h = document.createElement('h3');
      h.className = 'vge-day-panel__title';
      h.textContent = DOW_LONG[d.getDay()] + ', ' + MONTHS[d.getMonth()] + ' ' + d.getDate();
      el.day.appendChild(h);
      if (!evs.length) {
        var p = document.createElement('p');
        p.className = 'vge-day-panel__empty';
        p.textContent = 'Nothing on this day. Pick a highlighted date.';
        el.day.appendChild(p);
        return;
      }
      evs.forEach(function (it) { var c = cloneCard(it.id); if (c) el.day.appendChild(c); });
      syncSaveButtons();
    }

    /* ---------- spotlight: this month at a glance ---------- */
    function renderSpot() {
      if (!el.spot) return;
      var upcoming = data.items.filter(function (it) { return it.s && isActive(it, today) && it.kind !== 'trade'; });
      var inMonth = upcoming.filter(function (it) { return it.s.slice(0, 7) <= thisMonth && it.e >= today; });
      var list = inMonth.slice();
      var extended = false;
      if (list.length < 4) {
        upcoming.forEach(function (it) { if (list.length < 6 && list.indexOf(it) < 0) { list.push(it); extended = true; } });
      }
      if (el.spotTitle) el.spotTitle.textContent = 'Happening in ' + MONTHS[+thisMonth.slice(5) - 1];
      if (el.spotSub) {
        el.spotSub.textContent = inMonth.length
          ? inMonth.length + (inMonth.length === 1 ? ' thing' : ' things') + ' to do or celebrate this month' + (extended ? ', plus what’s next.' : '.')
          : 'Nothing left this month. Here’s what’s next.';
      }
      el.spot.innerHTML = list.map(function (it) { return miniCard(it, today, '#vge-' + it.id); }).join('');
    }

    function renderFeature() {
      var box = root.querySelector('[data-vge-feature]');
      if (!box) return;
      var pool = data.items.filter(function (it) { return it.k === 'event' && it.s && it.kind !== 'trade' && isActive(it, today); });
      var it = pool.filter(function (x) { return x.pick; })[0] || pool[0];
      if (!it) return;
      var s = parse(it.s), e = parse(it.e);
      var range = MON[s.getMonth()] + ' ' + s.getDate() +
        (it.e !== it.s ? '–' + (e.getMonth() !== s.getMonth() ? MON[e.getMonth()] + ' ' : '') + e.getDate() : '') + ', ' + e.getFullYear();
      box.innerHTML =
        '<p class="vge-feature__kicker">' + (it.pick ? 'Next VanillaGoods pick' : 'Next festival') + ' · ' + esc(relLabel(it, today)) + '</p>' +
        '<div class="vge-feature__row"><span class="vge-feature__date" aria-hidden="true"><span>' + MON[s.getMonth()] + '</span><strong>' + s.getDate() + '</strong></span>' +
        '<div><h2 class="vge-feature__name">' + esc(it.name) + '</h2>' +
        '<p class="vge-feature__meta">' + esc(range) + ' · ' + esc(whereLabel(it)) + '</p></div></div>' +
        (it.desc ? '<p class="vge-feature__desc">' + esc(it.desc) + '</p>' : '') +
        '<div class="vge-feature__actions"><a class="vge-btn vge-btn--gold" href="#vge-' + esc(it.id) + '" data-vge-jump="' + esc(it.id) + '">See details</a>' +
        (it.url ? '<a class="vge-btn vge-btn--ghost" href="' + esc(it.url) + '" target="_blank" rel="noopener">Tickets &amp; info<span class="visually-hidden"> (opens in a new tab)</span></a>' : '') + '</div>';
      box.hidden = false;
    }

    function spotNav() {
      var prev = root.querySelector('[data-vge-spot-prev]'), next = root.querySelector('[data-vge-spot-next]');
      if (!el.spot || !prev || !next) return;
      function update() {
        var max = el.spot.scrollWidth - el.spot.clientWidth - 2;
        prev.disabled = el.spot.scrollLeft <= 2;
        next.disabled = el.spot.scrollLeft >= max;
        prev.parentNode.hidden = max <= 0;
      }
      prev.addEventListener('click', function () { el.spot.scrollBy({ left: -el.spot.clientWidth * 0.9, behavior: 'smooth' }); });
      next.addEventListener('click', function () { el.spot.scrollBy({ left: el.spot.clientWidth * 0.9, behavior: 'smooth' }); });
      el.spot.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      update();
    }

    function fillStats() {
      var fest = 0, hol = 0, st = {};
      data.items.forEach(function (it) {
        if (!isActive(it, today)) return;
        if (it.k === 'holiday') hol++;
        else if (it.kind !== 'trade') { fest++; if (it.st) st[it.st] = 1; }
      });
      var map = { festivals: fest, holidays: hol, states: Object.keys(st).length };
      Array.prototype.forEach.call(root.querySelectorAll('[data-vge-stat]'), function (n) {
        var v = map[n.getAttribute('data-vge-stat')];
        if (v != null) n.textContent = v;
      });
    }

    /* ---------- reveal a specific card ---------- */
    function reveal(id, opts) {
      var card = document.getElementById('vge-' + id);
      if (!card) { if (!moreLoaded) loadMore().then(function () { reveal(id, opts); }); return; }
      var it = byId[id];
      if (state.view !== 'list') { state.view = 'list'; }
      if (it && !matches(it)) { state.topics = []; state.kinds = { festival: true, holiday: true, trade: true }; state.where = ''; state.q = ''; state.saved = false; }
      apply();
      requestAnimationFrame(function () {
        scrollToEl(card);
        card.classList.remove('is-flash');
        void card.offsetWidth;
        card.classList.add('is-flash');
        if (opts && opts.open) { var det = card.querySelector('details.vge-more'); if (det) det.open = true; }
        var title = card.querySelector('.vge-card__title');
        if (title) { title.setAttribute('tabindex', '-1'); title.focus({ preventScroll: true }); }
      });
    }

    /* ---------- save / share / calendar ---------- */
    function syncSaveButtons() {
      Array.prototype.forEach.call(root.querySelectorAll('[data-vge-save]'), function (b) {
        var host = b.closest('[data-id]');
        var on = host && saved.indexOf(host.getAttribute('data-id')) > -1;
        b.setAttribute('aria-pressed', String(!!on));
        b.title = on ? 'Saved' : 'Save';
      });
      if (el.savedCount) el.savedCount.textContent = saved.length;
    }

    var toastTimer = null;
    function toast(msg) {
      if (!el.toast) return;
      el.toast.textContent = msg;
      el.toast.classList.add('is-on');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { el.toast.classList.remove('is-on'); }, 2600);
    }

    function copyText(text) {
      if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(text);
      return new Promise(function (res, rej) {
        var ta = document.createElement('textarea');
        ta.value = text; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
        document.body.appendChild(ta); ta.select();
        try { document.execCommand('copy') ? res() : rej(); } catch (e) { rej(e); }
        ta.remove();
      });
    }

    var openPop = null;
    function closePop() {
      if (!openPop) return;
      var btn = openPop.btn;
      openPop.node.remove();
      btn.setAttribute('aria-expanded', 'false');
      openPop = null;
    }
    function openCalendarMenu(btn, it) {
      if (openPop && openPop.btn === btn) { closePop(); return; }
      closePop();
      var pop = document.createElement('div');
      pop.className = 'vge-pop';
      pop.setAttribute('role', 'menu');
      pop.innerHTML =
        '<a role="menuitem" href="' + esc(googleLink(it)) + '" target="_blank" rel="noopener">Google Calendar<span class="visually-hidden"> (opens in a new tab)</span></a>' +
        '<button role="menuitem" type="button" data-vge-ics-go>Apple Calendar (.ics)</button>' +
        '<a role="menuitem" href="' + esc(outlookLink(it)) + '" target="_blank" rel="noopener">Outlook.com<span class="visually-hidden"> (opens in a new tab)</span></a>' +
        '<button role="menuitem" type="button" data-vge-ics-go>Outlook desktop (.ics)</button>';
      btn.parentNode.appendChild(pop);
      pop.style.left = Math.max(0, btn.offsetLeft) + 'px';
      pop.style.top = (btn.offsetTop + btn.offsetHeight + 6) + 'px';
      btn.setAttribute('aria-expanded', 'true');
      openPop = { node: pop, btn: btn, it: it };
      var first = pop.querySelector('[role="menuitem"]');
      if (first) first.focus();
    }

    root.addEventListener('click', function (e) {
      var t = e.target;
      var b;

      if ((b = t.closest('[data-vge-ics-go]')) && openPop) { downloadICS(openPop.it); closePop(); return; }
      if (t.closest('.vge-pop a')) { setTimeout(closePop, 0); return; }

      if ((b = t.closest('[data-vge-cal]'))) {
        var host = b.closest('[data-id]');
        var it = host && byId[host.getAttribute('data-id')];
        if (it && it.s) openCalendarMenu(b, it);
        return;
      }
      if (openPop && !t.closest('.vge-pop')) closePop();

      if ((b = t.closest('[data-vge-save]'))) {
        var id = b.closest('[data-id]').getAttribute('data-id');
        var i = saved.indexOf(id);
        if (i > -1) saved.splice(i, 1); else saved.push(id);
        writeSaved(saved);
        syncSaveButtons();
        toast(i > -1 ? 'Removed from your saved list' : 'Saved. Use the “Saved” filter to see your list');
        if (state.saved) apply();
        return;
      }
      if ((b = t.closest('[data-vge-share]'))) {
        var sid = b.closest('[data-id]').getAttribute('data-id');
        var url = window.location.origin + window.location.pathname + '#vge-' + sid;
        var name = byId[sid] ? byId[sid].name : document.title;
        if (navigator.share && window.matchMedia('(pointer: coarse)').matches) {
          navigator.share({ title: name, url: url }).catch(function () { });
        } else {
          copyText(url).then(function () { toast('Link copied'); }, function () { toast(url); });
        }
        return;
      }
      if ((b = t.closest('[data-vge-jump]'))) {
        if (b.getAttribute('href') && b.getAttribute('href').charAt(0) !== '#') return; // teaser link to another page
        e.preventDefault();
        var jid = b.getAttribute('data-vge-jump');
        try { window.history.replaceState(null, '', window.location.pathname + window.location.search + '#vge-' + jid); } catch (err) { }
        reveal(jid, { open: true });
        return;
      }
      if ((b = t.closest('[data-vge-where-set]'))) {
        state.where = b.getAttribute('data-vge-where-set');
        apply();
        if (!state.where && el.where) el.where.focus();
        return;
      }
      if ((b = t.closest('[data-vge-jump-tba]'))) {
        e.preventDefault();
        var li = document.getElementById('vge-tba-' + b.getAttribute('data-vge-jump-tba'));
        if (!li && !moreLoaded) { loadMore().then(function () { b.click(); }); return; }
        if (li) {
          li.hidden = false;
          scrollToEl(li);
          li.classList.remove('is-flash'); void li.offsetWidth; li.classList.add('is-flash');
        }
        return;
      }
      if ((b = t.closest('[data-vge-topic]'))) {
        var tk = b.getAttribute('data-vge-topic');
        if (tk === 'all') state.topics = [];
        else {
          var ti = state.topics.indexOf(tk);
          if (ti > -1) state.topics.splice(ti, 1); else state.topics.push(tk);
        }
        apply(); return;
      }
      if ((b = t.closest('[data-vge-kind]'))) {
        var k = b.getAttribute('data-vge-kind');
        state.kinds[k] = !state.kinds[k];
        if (!state.kinds.festival && !state.kinds.holiday && !state.kinds.trade) { state.kinds[k] = true; toast('Keep at least one type selected'); }
        apply(); return;
      }
      if ((b = t.closest('[data-vge-saved]'))) {
        if (!saved.length && !state.saved) { toast('Tap the heart on any event to save it'); return; }
        state.saved = !state.saved; apply(); return;
      }
      if (t.closest('[data-vge-reset]')) { resetFilters(); return; }
      if ((b = t.closest('[data-vge-view]'))) {
        var v = b.getAttribute('data-vge-view');
        if (v === state.view) return;
        state.view = v;
        if (v === 'grid') {
          var a = el.rail && el.rail.getAttribute('data-active');
          state.month = a && a >= firstMonth ? a : firstMonth;
          state.day = null;
        }
        apply();
        setRailActive(state.view === 'grid' ? state.month : (el.rail.getAttribute('data-active') || firstMonth));
        return;
      }
      if ((b = t.closest('[data-vge-month]'))) { goMonth(b.getAttribute('data-vge-month')); return; }
      if (t.closest('[data-vge-grid-prev]')) { if (state.month > firstMonth) goMonth(prevMonth(state.month)); return; }
      if (t.closest('[data-vge-grid-next]')) { if (state.month < lastMonth) goMonth(nextMonth(state.month)); return; }
      if ((b = t.closest('[data-vge-day-btn]'))) {
        state.day = b.getAttribute('data-vge-day-btn');
        Array.prototype.forEach.call(el.grid.querySelectorAll('[data-vge-day-btn]'), function (x) {
          var on = x === b; x.classList.toggle('is-selected', on); x.setAttribute('aria-pressed', String(on));
        });
        renderDay();
        if (window.matchMedia('(max-width: 749px)').matches) scrollToEl(el.day);
        return;
      }
      if ((b = t.closest('[data-vge-filter-toggle]'))) {
        var open = b.getAttribute('aria-expanded') !== 'true';
        b.setAttribute('aria-expanded', String(open));
        if (el.filterPanel) el.filterPanel.classList.toggle('is-open', open);
        return;
      }
    });

    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && openPop) { var btn = openPop.btn; closePop(); btn.focus(); }
    });
    document.addEventListener('click', function (e) { if (openPop && !root.contains(e.target)) closePop(); });

    if (el.where) el.where.addEventListener('change', function () { state.where = el.where.value; apply(); });
    if (el.q) {
      var qt = null;
      el.q.addEventListener('input', function () {
        clearTimeout(qt);
        qt = setTimeout(function () { state.q = el.q.value.trim(); apply(); }, 160);
      });
      var form = el.q.closest('form');
      if (form) form.addEventListener('submit', function (e) { e.preventDefault(); state.q = el.q.value.trim(); apply(); });
    }

    window.addEventListener('hashchange', function () {
      var h = window.location.hash;
      if (h.indexOf('#vge-') === 0 && byId[h.slice(5)]) reveal(h.slice(5), { open: true });
    });

    /* ---------- boot ---------- */
    var bootHash = window.location.hash;
    readUrl();
    buildWhere();
    renderSpot();
    renderFeature();
    spotNav();
    fillStats();
    apply();
    try { var savedZip = localStorage.getItem(NEAR_KEY); if (savedZip && nearEl.zip) { nearEl.zip.value = savedZip; lookupZip(savedZip); } } catch (e) {}
    syncSaveButtons();
    setRailActive(state.view === 'grid' ? state.month : firstMonth);
    setupSpy();
    root.classList.add('is-ready');

    if (bootHash.indexOf('#vge-') === 0 && byId[bootHash.slice(5)]) setTimeout(function () { reveal(bootHash.slice(5), { open: true }); }, 60);
  }

  /* ---------- init all instances (and re-init in the theme editor) ---------- */
  function init(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-vge]'), function (root) {
      if (root.getAttribute('data-vge-init') === '1') return;
      var data = loadData(root);
      if (!data || !Array.isArray(data.items)) return;
      root.setAttribute('data-vge-init', '1');
      if (root.getAttribute('data-vge-mode') === 'teaser') initTeaser(root, data);
      else initGuide(root, data);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  // exposed for tests
  window.VGEvents = { buildICS: buildICS, googleLink: googleLink, fold: fold, relLabel: relLabel };
})();
